import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {AppConfigService} from '../../app-config.service';
import {ApiResponseObject} from '../../shared/model/api-response-object';

@Injectable({
  providedIn: 'root',
})
export class LogoutService {
  constructor(private readonly http: HttpClient,
              private readonly environment: AppConfigService) {}
              
  // Changing this to a parameterised method to avoid cyclic dependency
  logout(carrierCode: string): Observable<ApiResponseObject> {
    // Adjust to POST or GET depending on your API
    return this.http.get<ApiResponseObject>(
      `${this.environment.config.apiBaseEndpoint}/${carrierCode}/logout`);
  }
}

 